import { createSelector } from 'reselect';

const selectAllBooks = state => state.books.items || [];

const selectBookByProjectId = projectId => createSelector(
  selectAllBooks,
  books => Object.assign({}, books.find(book => book.projectId === projectId) || {}),
);

const selectRequestStatus = state => state.books.status;

export default {
  selectAllBooks,
  selectBookByProjectId,
  selectRequestStatus,
};
